<h1 mat-dialog-title>Inschrijven voor {{ event.name }}</h1>
<div mat-dialog-content>
  Je mag maximaal
  {{
    event.maxNumberTicketsPerSubscription - event.mySubscription.numberOfTickets
  }}
  ticket(s) erbij kopen.

  <mat-form-field>
    <input
      matInput
      placeholder="Aantal extra tickets"
      type="number"
      [formControl]="form"
      min="1"
      [max]="
        event.maxNumberTicketsPerSubscription -
        event.mySubscription.numberOfTickets
      "
    />
  </mat-form-field>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button
    mat-raised-button
    [disabled]="!form.valid"
    (click)="submit()"
    color="primary"
    cdkFocusInitial
  >
    Opslaan
  </button>
</mat-dialog-actions>
